import { render, staticRenderFns } from "./GiftCardSentEvent.vue?vue&type=template&id=266e662c"
import script from "./GiftCardSentEvent.vue?vue&type=script&lang=js"
export * from "./GiftCardSentEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports